var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIconB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6285 27.7772C13.3604 28.487 14.5483 28.487 15.2802 27.7772L24.807 18.5374L24.807 24.434C24.807 24.9163 25.0046 25.3789 25.3563 25.72C25.7079 26.0611 26.1849 26.2527 26.6823 26.2527C27.1796 26.2527 27.6566 26.0611 28.0083 25.72C28.3599 25.3789 28.5575 24.9163 28.5575 24.434L28.5575 14.147C28.5575 13.9081 28.5091 13.6716 28.4148 13.4509C28.3206 13.2302 28.1825 13.0297 28.0083 12.8608C27.8342 12.6919 27.6275 12.558 27.3999 12.4666C27.1724 12.3752 26.9285 12.3282 26.6823 12.3282L16.0757 12.3282C15.5783 12.3282 15.1013 12.5198 14.7497 12.8609C14.398 13.202 14.2004 13.6646 14.2004 14.147C14.2004 14.6293 14.398 15.0919 14.7497 15.433C15.1013 15.7741 15.5783 15.9657 16.0757 15.9657L22.1554 15.9657L12.6285 25.2055C11.8967 25.9153 11.8967 27.0674 12.6285 27.7772Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM2 20C2 29.9411 10.0589 38 20 38C29.9411 38 38 29.9411 38 20C38 10.0589 29.9411 2 20 2C10.0589 2 2 10.0589 2 20Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIconB);
export default __webpack_public_path__ + "static/media/arrow-icon-b.c11e6085a322eeac6196f2afc7fec819.svg";
export { ForwardRef as ReactComponent };